import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/ivm-consumption-api/:vendorApiId',
      component: component('views/ivm-consumption-api/IvmApiView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/Ivm` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/ivm-consumption-api/:vendorApiId',
          name: 'AppCustomer/VendorApis/IvmConsumptionApi',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/IvmConsumptionApi/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/IvmConsumptionApi/Settings',
          component: component('views/ivm-consumption-api/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
